<template>
  <div >
    <div   class="form-group-line mb-0 ">
      <i class="fa-solid fa-comments"></i>
      <input  @click="toggleInput2" ref="commentInput2" required type="text" class="form-control" :placeholder="$t('comments.placeholder')" />
    </div>

    <div v-if="show2" class="d-flex mt-2">
      <button @click="show2 = false" class="ml-auto btn btn-sm btn-pill btn-light-secondary">{{ $t('comments.cancel') }}</button>
      <button class="btn btn-sm btn-pill ml-2 btn-primary">{{ $t('comments.submit') }}<i class="fa-solid fa-paper-plane pl-1 small"></i></button>

    </div>
    <div v-for="item of comentarios" :key="item.id" class="d-flex mt-5">
      <div>
        <!-- <b-avatar class="ml-0"  size="lg" :src="item.Img_Usuario"></b-avatar> -->
          <b-avatar v-if="item.Img_Usuario != null" size="lg" :src="item.Img_Usuario"></b-avatar>
          <div v-else class="circle mr-2 bg-card" style="width: 50px !important; height: 30px !important">
            <div class="circle bg-icon-danger border" style="width: 50px !important; height: 50px !important">
              <i class="fa-solid fa-user danger" style="font-size: 1.5rem"></i>
            </div>
          </div>
      </div>
      <div class="ml-3" style="width: 100%;">
        <div class="d-flex   ">
          <span class="text-secondary">
            <i class="fa-solid fa-user px-2"></i>
            <span>{{item.Nombre}}</span>
          </span>
          <span class="text-secondary ml-2">
            <i class="fa-solid fa-clock px-2"></i>
            <span>{{item.Fecha}}</span>
          </span>
         
        </div>
        <hr class="my-1">
        <p class="text-secondary pt-2 pr-lg-5 mr-lg-5 mb-0">
          {{item.Descripcion}}
        </p>
        <div class="d-flex">
          <span @click="toggleInput" class="a pointer ml-auto">
            <span :class="show ? 'text-primary' : ''">
              <i class="fa-solid fa-reply mr-1"></i>
              {{ $t('comments.reply') }}
            </span>
          </span>
        </div>

        <div v-if="show" class="form-group-line mb-0">
          <i class="fa-solid fa-comments"></i>
          <input ref="commentInput" required type="text" class="form-control" :placeholder="$t('comments.placeholder')" />
        </div>

        <div v-if="show" class="d-flex mt-2">
          <button @click="show = false" class="ml-auto btn btn-sm btn-pill btn-light-secondary">{{ $t('comments.cancel') }}</button>
          <button class="btn btn-sm btn-pill ml-2 btn-primary">{{ $t('comments.submit') }}<i class="fa-solid fa-paper-plane pl-1 small"></i></button>
        </div>
         
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:[
    "TagsButton"
  ],
  data() {
    return {
       show: false,
       show2: false,
       comentarios:[
         {id: 1, Descripcion: 'Se pueden utilizar distintos tipos de tenencia de vivienda para el mismo tipo físico. Por ejemplo, las residencias conectadas pueden ser propiedad de una sola entidad y estar arrendadas. Las residencias se pueden clasificar por su conexión con las residencias y los terrenos vecinos.', Nombre: 'Alejandro', Fecha: '9 de Julio 2025', Img_Usuario: 'https://randomuser.me/api/portraits/men/32.jpg' },
         {id: 2, Descripcion: 'Se pueden utilizar distintos tipos de tenencia de vivienda para el mismo tipo físico. Por ejemplo, las residencias conectadas pueden ser propiedad de una sola entidad y estar arrendadas. Las residencias se pueden clasificar por su conexión con las residencias y los terrenos vecinos.', Nombre: 'Juan', Fecha: '5 de Junio 2025', Img_Usuario: 'https://randomuser.me/api/portraits/men/32.jpg' },
         {id: 3, Descripcion: 'Se pueden utilizar distintos tipos de tenencia de vivienda para el mismo tipo físico. Por ejemplo, las residencias conectadas pueden ser propiedad de una sola entidad y estar arrendadas. Las residencias se pueden clasificar por su conexión con las residencias y los terrenos vecinos.', Nombre: 'Alexa', Fecha: '5 de Junio 2025', Img_Usuario: 'https://randomuser.me/api/portraits/men/32.jpg' },
         
       ]
    };
  },
  methods: {
    toggleInput() {
      this.show = !this.show;
      if (this.show) {
        this.$nextTick(() => {
          this.$refs.commentInput.focus();
        });
      }
    },
    toggleInput2() {
      this.show2 = true;
      if (this.show2) {
        this.$nextTick(() => {
          this.$refs.commentInput2.focus();
        });
      }
    }
     
  },
};
</script>

<style scoped>

.heart-animation {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
  color: rgb(255, 255, 255);
  opacity: 0;
  animation: none;
}


.heart-animation.active {
  animation: heart-pop 1s ease-out forwards;
}

@keyframes heart-pop {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

.icon-button {
  background: var(--white);
  color: var(--black);
  border: none;
  padding: 3px;
  border-radius: 5px;
  width: 2.2rem;
  height: 2.2rem;
  font-size: 18px;
  cursor: pointer;
  outline: none;
}
.action-buttons {
  position: absolute;
  bottom:30px;
  right: 10px;
  /* display: flex; */
  gap: 10px;
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent; 
  /* border-radius: 0px; */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent; 
}
.product-gallery {
  /* overflow: hidden;
  
  display: flex;
  flex-direction: column;
  align-items: center; */


 

  position: relative;
  width: 100%;
  /* max-width: 400px; */
 
  overflow: hidden;
}

.carousel-wrapper {
  width: 100%;
  /* max-width: 100%; */
  margin-bottom: 15px;
}

.image-container {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.main-image {
  position: relative;

  width: 100vw;
  max-width: 800px;
  /* min-height: 800px; */
  max-height: 100%;
  /* border-radius: 8px; */
}

.thumbnails-wrapper {
  display: flex;
  /* width: 100vh !important; */
  align-items: center;
}

.thumbnails {
  width: 100vw !important;
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px;
  scroll-behavior: smooth;
}

.thumbnail {
  width: 8rem;
  /* width: 100vh !important; */
  height: 6rem;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s;
  /* border-radius: 4px; */
}

.thumbnail.active {
  /* border-color: #007bff; */
}

.thumbnail:hover {
  /* border-color: #0056b3; */
}

.nav-button {
  margin-top: -1rem;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  border-radius: 100px !important;
  transition: color 0.2s;
}
 @media (max-width: 576px) {
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30vh;
  }
} 
 @media (max-width: 720px) {
  .main-image {
height: 20vh;
  width: 100vw;
  /* max-width: 100%; */
  height: 100%;
  /* border-radius: 8px; */
}
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh !important;
  }
} 

 
</style>